import routeHandler from './routes';

import MODULE_ID from './moduleId';

const module = {
  moduleType: 'Form',
  moduleId: MODULE_ID,
  api: 'forms',

  routeHandler,
};
export default module;
